import { defineStore } from 'pinia';
import { UserActionEnum } from '../constants';

export default defineStore('userAction', {
  state: () => ({
    userAction: UserActionEnum.SMS_PAGE_OPEN,
  }),
  getters: {
    getUserAction: (state) => state.userAction,
  },
  actions: {
    loadUserAction(value) {
      const userActions = Object.values(UserActionEnum);

      const setUserAction = (action) => {
        if (userActions.includes(action)) {
          this.userAction = action;
        }
      };

      if (!value) {
        setUserAction(UserActionEnum.SMS_PAGE_OPEN);
      } else {
        setUserAction(value);
      }
    },
  },
});
